import { Link } from 'react-router-dom';
import AgencyNav from './AgencyNav';
import AgencyFooter from './AgencyFooter';
import Waitlist from './Waitlist';
import RevealOnScroll from './RevealOnScroll';
import Seo from './Seo';
import { frontOs } from '../../content/agencyCopy';

export default function FrontOSProduct() {
  return (
    <div className="fa-scope min-h-screen">
      <Seo
        title="Front OS — Desktop assistant · FRONTECH"
        description="Desktop assistant that remembers what you're working on. Built for people who live in ten applications at once. In development — join the waitlist."
        path="/front-os"
      />
      <AgencyNav />

      <main>
        {/* Hero */}
        <section
          className="pt-40 md:pt-48 pb-20 md:pb-28 px-6"
          style={{ background: 'var(--fa-paper)' }}
        >
          <div className="max-w-[1120px] mx-auto">
            <Link
              to="/"
              className="fa-hero-item inline-flex items-center gap-1.5 fa-mono text-[11px] px-2.5 py-1.5 rounded-md mb-6 transition-colors hover:opacity-80"
              data-i="0"
              style={{
                color: 'var(--fa-muted)',
                border: '1px solid var(--fa-rule)',
                letterSpacing: '0.06em',
                textTransform: 'uppercase',
                background: 'var(--fa-surface)',
              }}
              aria-label="Back to FRONTECH agency site"
            >
              ← Agency
            </Link>
            <div className="fa-label fa-hero-item flex items-center gap-3" data-i="0">
              <span className="fa-status-dot fa-status-dot--live" aria-hidden="true" />
              {frontOs.eyebrow}
            </div>
            <h1
              className="fa-hero-item mt-6 font-display text-[34px] sm:text-[44px] md:text-[54px]"
              data-i="1"
              style={{ maxWidth: '22ch' }}
            >
              {frontOs.headline}
            </h1>
            <p
              className="fa-hero-item mt-8 text-[17px] md:text-[18px] max-w-[60ch]"
              data-i="2"
              style={{ color: 'var(--fa-ink)' }}
            >
              {frontOs.subline}
            </p>
          </div>
        </section>

        {/* Waitlist */}
        <section
          className="px-6 py-20 md:py-24"
          style={{
            background: 'var(--fa-surface)',
            borderTop: '1px solid var(--fa-rule)',
            borderBottom: '1px solid var(--fa-rule)',
          }}
        >
          <RevealOnScroll className="max-w-[1120px] mx-auto grid md:grid-cols-12 gap-10 md:gap-16 items-start">
            <div className="md:col-span-5">
              <h2 className="font-display text-[26px] md:text-[34px]" style={{ maxWidth: '18ch' }}>
                {frontOs.waitlist.headline}
              </h2>
            </div>
            <div className="md:col-span-7">
              <p
                className="mb-6 text-[16px]"
                style={{ color: 'var(--fa-ink)', maxWidth: '52ch' }}
              >
                {frontOs.waitlist.body}
              </p>
              <Waitlist product="front-os" source="front-os-page" />
            </div>
          </RevealOnScroll>
        </section>

        {/* Credibility */}
        <section
          className="px-6 py-24 md:py-32"
          style={{ background: 'var(--fa-paper)' }}
        >
          <RevealOnScroll className="max-w-[1120px] mx-auto grid md:grid-cols-12 gap-10 md:gap-16">
            <div className="md:col-span-4">
              <div className="fa-label flex items-center gap-3">
                <span className="fa-status-dot fa-status-dot--live" aria-hidden="true" />
                {frontOs.credibility.label}
              </div>
            </div>
            <p
              className="md:col-span-8 text-[16px] md:text-[17px]"
              style={{ color: 'var(--fa-ink)', maxWidth: '60ch' }}
            >
              {frontOs.credibility.body}
            </p>
          </RevealOnScroll>
        </section>
      </main>

      <AgencyFooter />
    </div>
  );
}
